import { cn, NoddiIcon, NoddiIconName, type VariantProps } from 'noddi-ui-common';
import { PropsWithChildren } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { noddiButtonVariants } from '../Inputs/NoddiButton';

export type NoddiLinkProps = LinkProps &
  VariantProps<typeof noddiButtonVariants> & {
    loading?: boolean;
    spanClassName?: string;
  } & ({ startIcon?: NoddiIconName; endIcon?: never } | { endIcon?: NoddiIconName; startIcon?: never });

export const NoddiLink = ({
  className,
  variant,
  size,
  children,
  startIcon,
  endIcon,
  spanClassName,
  ...props
}: PropsWithChildren<NoddiLinkProps>) => {
  const buttonClassName = cn(noddiButtonVariants({ variant, size }), className);

  return (
    <Link className={buttonClassName} {...props}>
      {/* Icons inherit the link's own text color — see the note in NoddiButton. */}
      {startIcon && <NoddiIcon name={startIcon} />}

      <span className={cn('text-left', spanClassName)}>{children}</span>

      {endIcon && <NoddiIcon name={endIcon} />}
    </Link>
  );
};
